<template>
  <div>

    <!--导航栏 start-->
    <van-nav-bar title="开通扫码点餐" left-text="返回" left-arrow fixed @click-left="onClickLeft" />
    <!--导航栏 end-->
    <!--内容部分 start-->

    <van-form ref="forms" style="margin-top: 1.2rem">
      <van-field
        readonly
        clickable
        name="选择商户"
        :value="selectMerchant.name"
        label="选择商户"
        placeholder="点击选择商户"
        :rules="[{ required: true, message: '' }]"
        @click="show_merchantList = true"
      />
      <!-- <van-dropdown-menu active-color="#1989fa" v-if="selectMerchant.name">
				<van-dropdown-item :title="select_stores.store_name ? select_stores.store_name : '选择门店'" ref="store">
					<van-cell
						v-for="item in storeList"
						:key="item.id"
						:class="select_stores.id == item.id ? 'store_checked' : ''"
						:title="item.store_name"
						:value="item.is_code == 0 ? '未开通' : '已开通'"
						@click="selectList(item)">
					</van-cell>
				</van-dropdown-item>
			</van-dropdown-menu> -->
      <van-field
        v-if="selectMerchant.name"
        ref="store"
        readonly
        clickable
        label="选择门店"
        :value="select_stores.store_name"
        placeholder="选择门店"
        @click="showStore = true"
      />
      <van-popup v-model="showStore" round position="bottom" style="padding: 1.2rem 0 0.2rem;" closeable>
        <van-cell
          v-for="item in storeList"
          :key="item.id"
          :class="select_stores.id == item.id ? 'store_checked' : ''"
          :title="item.store_name"
          :value="item.is_code == 0 ? '未开通' : '已开通'"
          @click="selectList(item)"
        />
      </van-popup>

      <div v-if="select_stores.store_name">
        <van-field
          v-model="code"
          label="点餐码"
          name="点餐码"
          clearable
          placeholder="请输入点餐码"
          :error-message="code_error"
          @input="verCode"
        />
        <van-field v-model="alipay_pid" label="支付宝商户号" name="支付宝商户号" clearable placeholder="请输入支付宝商户号" />
        <van-field
          v-model="store_name"
          label="门店名称"
          required
          name="门店名称"
          clearable
          placeholder="请输入门店名称"
          :rules="[{ required: true, message: '门店名称不能为空' }]"
        />
        <van-field
          v-model="store_contact"
          label="门店联系人"
          required
          name="门店联系人"
          clearable
          placeholder="请输入门店联系人"
          :rules="[{ required: true, message: '门店联系人不能为空' }]"
        />
        <van-field
          v-model="store_tel"
          label="门店手机号"
          required
          name="门店手机号"
          clearable
          placeholder="请输入门店手机号"
          :rules="[{ required: true, message: '门店手机号不能为空' }]"
        />
        <van-field v-model="store_info" label="门店信息" name="门店信息" clearable placeholder="请输入门店信息" />
        <van-field
          readonly
          clickable
          label="选择地址"
          :value="value"
          placeholder="请选择地址"
          required
          :rules="[{ required: true, message: '地址必须选择' }]"
          @click="showPicker = true"
        />
        <van-popup v-model="showPicker" round position="bottom">
          <van-picker show-toolbar :columns="area" @cancel="showPicker = false" @confirm="onConfirm" />

        </van-popup>
        <van-field
          readonly
          clickable
          label="店铺分类"
          :value="value2"
          placeholder="请店铺分类"
          required
          :rules="[{ required: true, message: '店铺分类必须选择' }]"
          @click="showPicker2 = true"
        />
        <van-popup v-model="showPicker2" round position="bottom">
          <van-picker show-toolbar :columns="type" @cancel="showPicker2 = false" @confirm="onConfirm2" />

        </van-popup>
        <van-field name="uploader" label="门店图片" required :rules="[{ required: true, message: '门店图片不能为空' }]">
          <template #input>
            <van-uploader v-model="imageList" :after-read="afterRead" multiple :max-count="1" />
          </template>
        </van-field>
        <van-field name="uploader" label="门店组图" required :rules="[{ required: true, message: '门店组图不能为空' }]">
          <template #input>
            <van-uploader v-model="imageLists" :after-read="afterReads" multiple @delete="deletes" />
          </template>
        </van-field>

        <van-field name="是否营业" label="是否营业" required :rules="[{ required: true, message: '是否营业必须选择' }]">
          <template #input>
            <van-radio-group v-model="store_is_start" direction="horizontal">
              <van-radio :name="1">开业</van-radio>
              <van-radio :name="0">暂停营业</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="是否开通外卖" label="是否开通外卖" required :rules="[{ required: true, message: '是否开通外卖必须选择' }]">
          <template #input>
            <van-radio-group v-model="is_delivery" direction="horizontal">
              <van-radio :name="1">是</van-radio>
              <van-radio :name="0">否</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          v-if="is_delivery == 1"
          v-model="delivery_money"
          label="配送费"
          required
          name="配送费"
          clearable
          placeholder="请输入配送费"
          :rules="[{ required: true, message: '配送费不能为空' }]"
        />
        <van-field name="店铺经营类型" label="店铺经营类型" required :rules="[{ required: true, message: '店铺经营类型必须选择' }]">
          <template #input>
            <van-radio-group v-model="shop_type" direction="horizontal">
              <van-radio name="01">直营</van-radio>
              <van-radio name="02">加盟</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field
          readonly
          clickable
          label="餐饮类型"
          :value="value3"
          placeholder="选择餐饮类型"
          @click="showDinner_type = true"
        />
        <van-popup v-model="showDinner_type" round position="bottom">
          <van-picker
            show-toolbar
            :columns="dinner_typeList"
            @cancel="showDinner_type = false"
            @confirm="onConfirm3"
          />
        </van-popup>
      </div>

    </van-form>
    <div style="margin: 16px;">
      <van-button round block type="info" native-type="submit" @click="openCode">
        开通扫码点餐
      </van-button>
    </div>

    <!-- <div style="margin: 0 auto; margin-top: 50px;width: 200px;padding: 0;">
		    <van-button @click="store_info" round block type="info" native-type="submit">
		        补充资料
		    </van-button>
		</div> -->

    <!--内容部分 end-->
    <!-- 商户列表弹出框 -->
    <van-popup v-model="show_merchantList" round position="bottom">
      <van-picker
        show-toolbar
        :columns="merchantList"
        @cancel="show_merchantList = false"
        @confirm="changeMerchant"
      />
    </van-popup>
    <van-popup v-model="show_merchantList" class="popup" position="bottom">
      <form action="/" style="margin-bottom: 10px">
        <van-search v-model="keyword" placeholder="如商户不在列表内，请点此搜索查询" @search="onSearch" />
      </form>
      <van-picker
        show-toolbar
        :columns="merchantList"
        toolbar-position="bottom"
        @cancel="show_merchantList = false"
        @confirm="changeMerchant"
      />
      <div style="height: 30px" />
    </van-popup>

  </div>
</template>

<script>
import { Notify, Toast } from 'vant'
import Config from '../../../config'
import area from '@/utils/area.js'
import industryType from '@/utils/type.js'
export default {
  data() {
    return {
      selectMerchant: {
        name: '',
        id: 0
      },
      keyword: '',
      merchantList: [],
      show_merchantList: false,
      select_store: '',
      showStore: false,
      select_stores: '',
      show: false,
      store_ids: [],
      storeList: [],
      code: '',
      alipay_pid: '',
      index: '',
      imageList: [{ url: '' }],
      imageLists: [],
      store_contact: '',
      store_img: '',
      order_group_images: [],
      store_is_start: '',
      is_delivery: 0,
      store_name: '',
      store_tel: '',
      store_info: '',
      store_id: '',
      code_error: '',
      value: '',
      value2: '',
      showPicker: false,
      showPicker2: false,
      area: [],
      type: [],
      alipay_city_code: '',
      alipay_district_code: '',
      alipay_province_code: '',
      alipay_shop_category: '',
      shop_type: '',
      delivery_money: '',
      showDinner_type: false,
      value3: '',
      dinner_type: '',
      dinner_typeList: [
        {
          'code': 'A01',
          'text': '正餐-本帮江浙菜'
        },
        {
          'code': 'A02',
          'text': '正餐-日本菜'
        },
        {
          'code': 'A03',
          'text': '正餐-西餐'
        },
        {
          'code': 'A04',
          'text': '正餐-粤菜'
        },
        {
          'code': 'A05',
          'text': '正餐-韩国料理'
        },
        {
          'code': 'A06',
          'text': '正餐-川菜'
        },
        {
          'code': 'A07',
          'text': '正餐-东南亚菜'
        },
        {
          'code': 'A08',
          'text': '正餐-江河湖海鲜'
        },
        {
          'code': 'A09',
          'text': '正餐-东北菜'
        },
        {
          'code': 'A10',
          'text': '正餐-新疆菜'
        },
        {
          'code': 'A11',
          'text': '正餐-素食'
        },
        {
          'code': 'A12',
          'text': '正餐-湘菜'
        },
        {
          'code': 'A13',
          'text': '正餐-早茶'
        },
        {
          'code': 'A14',
          'text': '正餐-北京菜'
        },
        {
          'code': 'A15',
          'text': '正餐-农家菜'
        },
        {
          'code': 'A16',
          'text': '正餐-家常菜'
        },
        {
          'code': 'A17',
          'text': '正餐-特色菜'
        },
        {
          'code': 'A18',
          'text': '正餐-私房菜'
        },
        {
          'code': 'A19',
          'text': '正餐-创意菜'
        },
        {
          'code': 'A20',
          'text': '正餐-中东菜'
        },
        {
          'code': 'B01',
          'text': '快餐-小吃快餐'
        },
        {
          'code': 'B02',
          'text': '快餐-小龙虾'
        },
        {
          'code': 'B03',
          'text': '快餐-烧烤烤串'
        },
        {
          'code': 'B04',
          'text': '快餐-面馆'
        },
        {
          'code': 'B05',
          'text': '快餐-烤肉'
        },
        {
          'code': 'C01',
          'text': '火锅-火锅'
        },
        {
          'code': 'D01',
          'text': '面包甜点-面包甜点'
        },
        {
          'code': 'E01',
          'text': '茶饮咖啡-咖啡厅'
        },
        {
          'code': 'E02',
          'text': '茶饮咖啡-饮品店'
        },
        {
          'code': 'F01',
          'text': '零食卤味-水果生鲜'
        },
        {
          'code': 'F02',
          'text': '零食卤味-食品保健'
        },
        {
          'code': 'F03',
          'text': '零食卤味-卤味熟食'
        },
        {
          'code': 'F04',
          'text': '零食卤味-零食干果'
        },
        {
          'code': 'G01',
          'text': '酒餐-酒店自助餐'
        }
      ]
    }
  },
  // 组件内路由--进入组件时
  beforeRouteEnter(to, from, next) {
    window.document.body.style.backgroundColor = '#f5f5f5'
    next()
  },
  // 组件内路由--离开组件时
  beforeRouteLeave(to, from, next) {
    window.document.body.style.backgroundColor = ''
    next()
  },
  created() {
    // this.merchant_id=this.$route.query.merchant_id;

  },
  mounted() {
    this.area = area.area
    this.type = industryType.type
    this.getMerchantList()
  },
  // activated() {
  //   this.getMerchantList();
  // },
  methods: {
    onSearch(v) {
      this.keyword = v
      this.getMerchantList(2)
    },
    // 获取商户列表
    getMerchantList(type) {
      var reqData = {
        keyword: this.keyword,
        type: 1
      }
      this.$http
        .get('/wechat/api.salesman/merchants', {
          params: reqData
        })
        .then((res1) => {
          var res = res1.body
          console.log(res)
          var values = []
          var defaultIndex = 0
          var merchant_id = []
          if (res.data.length == 0) {
            this.$dialog.confirm({
              title: '暂无商户',
              // message: "弹窗内容",
              showCancelButton: false
            })
              .then(() => {
                if (type == 2) {
                  this.keyword = '',
                  this.getMerchantList()
                  return
                }
                this.$router.go(-1)
              })
              .catch((err) => {
                console.log(err)
              })
          }
          res.data.map((v) => {
            values.push(`${v.store_name}(${v.merchant_num})`)
            merchant_id.push(v.merchant_id)
          })
          var obj = {
            values,
            defaultIndex,
            merchant_id
          }
          this.merchantList = []
          this.merchantList.push(obj)
          console.log(this.merchantList)
        })
    },
    // 选择商户
    changeMerchant(v, i) {
      console.log(v, i)
      this.selectMerchant.name = v[0]
      console.log(this.merchantList)
      this.selectMerchant.id = this.merchantList[0].merchant_id[i[0]]
      console.log(this.selectMerchant)
      this.show_merchantList = false
      this.select_stores = ''
      this.listStore()
    },
    getSelectAlipayShopCategory(code, arr) {
      let index = 0
      let p_index = 0
      let text = ''
      let p_text = ''
      for (let i = 0; i < arr.length; i++) {
        const children = arr[i].children
        for (let j = 0; j < children.length; j++) {
          if (children[j].code == code) {
            p_index = i
            index = j
            p_text = arr[i].text
            text = children[j].text
          }
        }
      }
      return { p_index, index, p_text, text }
    },
    onConfirm(value, index) {
      this.value = value
      this.alipay_province_code = this.area[index[0]].code
      this.alipay_city_code = this.area[index[0]].children[index[1]].code
      this.alipay_district_code = this.area[index[0]].children[index[1]].children[index[2]].code
      this.showPicker = false
    },
    onConfirm2(value, index) {
      this.value2 = value
      this.alipay_shop_category = this.type[index[0]].children[index[1]].code
      this.showPicker2 = false
    },
    onConfirm3(value, index) {
      this.value3 = value.text
      this.dinner_type = value.code
      this.showDinner_type = false
    },
    selectList(action, index) {
      this.select_stores = action
      // this.$refs.store.toggle();
      this.showStore = false
      this.store_id = this.select_stores.id
      this.imageList = [{ url: '' }]
      this.imageLists = []
      this.getStore()
    },
    listStore() {
      this.$http.post('/wechat/api.salesman/storeList', { merchant_id: this.selectMerchant.id }).then(response => {
        if (response && response.body.code == 200) {
          this.storeList = response.body.data
          response.body.data.map(item => {
            item.name = item.store_name
          })
        }
      })
    },
    getStore(res) {
      this.$http
        .get('/wechat/api.salesman/get_store_info', {
          params: {
            merchant_id: this.selectMerchant.id,
            store_id: this.store_id
          }
        })
        .then((response) => {
          if (response && response.body.code == 200) {
            this.code = response.body.data.code
            this.alipay_pid = response.body.data.alipay_pid
            this.store_contact = response.body.data.store_contact
            this.store_is_start = response.body.data.store_is_start
            this.is_delivery = response.body.data.is_delivery
            this.store_name = response.body.data.store_name
            this.store_tel = response.body.data.store_tel
            this.store_info = response.body.data.store_info
            this.shop_type = response.body.data.shop_type
            this.alipay_city_code = response.body.data.alipay_city_code
            this.alipay_district_code = response.body.data.alipay_district_code
            this.alipay_province_code = response.body.data.alipay_province_code
            this.alipay_shop_category = response.body.data.alipay_shop_category
            this.delivery_money = response.body.data.delivery_money
            this.dinner_type = response.body.data.dinner_type
            this.dinner_typeList.map(i => {
              if (this.dinner_type == i.code) {
                this.value3 = i.text
              }
            })
            const index_arr = []
            const text_arr = []
            const sheng_code = this.alipay_province_code
            const shi_code = this.alipay_city_code
            const qu_code = this.alipay_district_code
            for (let i0 = 0; i0 < this.area.length; i0++) {
              if (this.area[i0].code == sheng_code) {
                index_arr[0] = i0
                text_arr[0] = this.area[i0].text
                const shi_arr = this.area[i0].children
                for (let i1 = 0; i1 < shi_arr.length; i1++) {
                  if (shi_arr[i1].code == shi_code) {
                    index_arr[1] = i1
                    text_arr[1] = shi_arr[i1].text
                    const qu_arr = shi_arr[i1].children
                    for (let i2 = 0; i2 < qu_arr.length; i2++) {
                      if (qu_arr[i2].code == qu_code) {
                        index_arr[2] = i2
                        text_arr[2] = qu_arr[i2].text
                      }
                    }
                  }
                }
              }
            }
            this.value = text_arr
            const select = this.getSelectAlipayShopCategory(this.alipay_shop_category, this.type)
            console.log('ddddddddddd', select)
            if (select.p_text != '') {
              this.value2 = select.p_text + ',' + select.text
            }
            if (response.body.data.store_img) {
              this.imageList[0].url = (Config.baseURL + response.body.data.store_img)
              this.store_img = response.body.data.store_img
            } else {
              this.imageList = []
              this.store_img = null
            }
            if (response.body.data.order_group_images) {
              this.imageLists = []
              response.body.data.order_group_images.map(item => {
                const obj = { url: Config.baseURL + item }
                this.imageLists.push(obj)
              })

              this.order_group_images = response.body.data.order_group_images
            } else {
              this.imageLists = []
              this.order_group_images = null
            }
          }
        })
    },
    afterRead(file) {
      this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
        localData: file.content,
        openid: window.localStorage.getItem('openid')

      }).then(response => {
        if (response && response.data.code == 200) {
          this.store_img = response.data.local_img
        }
      })
    },
    afterReads(file) {
      this.$http.post('/wechat/api.merchant/wechatUploadMerchantImg', {
        localData: file.content,
        openid: window.localStorage.getItem('openid')

      }).then(response => {
        if (response && response.data.code == 200) {
          this.order_group_images.push(response.data.local_img)
        }
      })
    },
    deletes(file, detail) {
      this.order_group_images.splice(detail.index, 1)
    },

    // 左侧返回
    onClickLeft() {
      this.$router.push('/SalesmanHomepage')
      // window.history.go(-1)
    },

    openCode() {
      // var toast = Toast.loading({
      //   message: '正在开通',
      //   forbidClick: true,
      //   loadingType: 'spinner',
      // });
      this.$http.get('/wechat/api.salesman/openCode', {
        params: {
          store_id: this.store_id,
          code: this.code,
          alipay_pid: this.alipay_pid,
          store_contact: this.store_contact,
          store_is_start: this.store_is_start,
          is_delivery: this.is_delivery,
          store_name: this.store_name,
          store_tel: this.store_tel,
          store_info: this.store_info,
          store_img: this.store_img,
          order_group_images: this.order_group_images,
          alipay_city_code: this.alipay_city_code,
          alipay_district_code: this.alipay_district_code,
          alipay_province_code: this.alipay_province_code,
          alipay_shop_category: this.alipay_shop_category,
          shop_type: this.shop_type,
          delivery_money: this.delivery_money,
          dinner_type: this.dinner_type
        }
      }).then(response => {
        if (response && response.body.code == 200) {
          Notify({ type: 'success', message: response.body.msg })
          setTimeout(() => {
            this.$router.go(0)
            // this.$router.push("/SalesmanHomepage")
          }, 200)
        } else {
          Notify({ type: 'danger', message: response.body.msg })
        }
      })
    },
    verCode() {
      this.$http.get('/wechat/api.salesman/verCode', { params: { code: this.code, store_id: this.store_id }}).then(response => {
        console.log(response)
        if (response.body.code != 200) {
          this.code_error = response.body.msg
        }
      })
    }

  }
}
</script>

<style >
.van-icon-goods-collect-o::before {
	position: relative;
	top: 0.1rem;
}

.van-icon-contact::before {
	position: relative;
	top: 0.1rem;
}

.van-field>>>.van-field__label {
	width: 30px;
}

.store_checked {
	color: #1989fa;
}
</style>
